const siccij = {
    C001Areas: 'SICCIJ/Catalogos/GetAreas',
    C012TiposEstatusDeCitas: 'SICCIJ/Catalogos/GetTiposEstatusDeCitas',
    C013TiposTramites: 'SICCIJ/Catalogos/GetTiposTramites',
    C014TiposEstatusDeTramitesCitas: 'SICCIJ/Catalogos/GetTiposEstatusDeTramitesCitas',
    C015TiposEstatusDeExpedientes: 'SICCIJ/Catalogos/GetTiposEstatusDeExpedientes',
    C004AgendaBloquesFechas: 'SICCIJ/Catalogos/GetAgendaBloqueFechas',
    C004AgendaBloquesHoras: 'SICCIJ/Catalogos/GetAgendaBloqueHoras'
  };
  
  export default siccij;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICCIJ/catalogos/siccij.js
// module id = null
// module chunks = 